import React, { useState, useEffect } from "react";
import OptocinetiqueTexte from "./OptocinetiqueTexte";

export const OptocinetiqueBarresTexteLauncher = ({
  caseSize,
  text,
  type,
  wpcm, // Mots par minute
}: {
  wpcm: number;
  caseSize: number;
  text: string;
  type: string;
}) => {
  const [selectedSentence, setSelectedSentence] = useState<string>("");
  const [isCrossVisible, setIsCrossVisible] = useState<boolean>(true);
  const [isRunning, setIsRunning] = useState<boolean>(false); // Contrôle du défilement
  const [isPaused, setIsPaused] = useState<boolean>(false);

// Fonction pour sélectionner une phrase ou deux à un endroit aléatoire
const selectSentence = (inputText: string, type: string): string => {
  const sentences = inputText.match(/[^.!?]+[.!?]+/g) || [];
  
  if (sentences.length === 0) {
    return "Le texte ne contient pas de phrases.";
  }
  
  // Générer un index de départ aléatoire
  const randomIndex = Math.floor(Math.random() * sentences.length);
  
  // Commencer à parcourir les phrases à partir de l'index aléatoire
  for (let i = randomIndex; i < sentences.length + randomIndex; i++) {
    const currentIndex = i % sentences.length; // Pour boucler au début si on atteint la fin
    const wordCount = sentences[currentIndex].trim().split(/\s+/).length;

    // Si la phrase a plus de 20 mots, on la retourne
    if (wordCount > 20) {
      const selectedText = sentences[currentIndex].trim();
      return type === "barres" ? selectedText.replace(/[^ ]/g, '/') : selectedText;
    }

    // Si deux phrases consécutives ont chacune moins de 20 mots, on les retourne ensemble
    if (currentIndex < sentences.length - 1) {
      const nextIndex = (currentIndex + 1) % sentences.length;
      const nextWordCount = sentences[nextIndex].trim().split(/\s+/).length;
      if (wordCount < 20 && nextWordCount < 20) {
        const selectedText = `${sentences[currentIndex].trim()} ${sentences[nextIndex].trim()}`;
        return type === "barres" ? selectedText.replace(/[^ ]/g, '/') : selectedText;
      }
    }
  }

  return "Aucune phrase ne correspond aux critères.";
};

  // Gérer la fin du défilement
  const handleScrollEnd = () => {
    setIsCrossVisible(true); // Affiche la croix noire à la fin du défilement
  };

  // Relancer une nouvelle salve de texte
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.code === "Space") {
      if (isCrossVisible) {
        setIsCrossVisible(false); // Masquer la croix
        setSelectedSentence(selectSentence(text, type)); // Sélectionner une nouvelle phrase
        setIsRunning(true); // Relancer le défilement
      }
    }
  };

  const handleFullscreenChange = () => {
    const isFullscreen = !!document.fullscreenElement;
    setIsPaused(!isFullscreen)
  };


  // Gestion des événements de clavier
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("fullscreenchange", handleFullscreenChange);

    };
  }, [isCrossVisible, text]);

  // Sélectionner une phrase à l'initialisation
  useEffect(() => {
    setSelectedSentence(selectSentence(text, type));
  }, [text]);

  return (
    <div>
      {isCrossVisible && <FullScreenCross size={caseSize*0.7/4} />} {/* Affiche la croix */}
      {isPaused && <FullScreenCross size={caseSize*0.7/4} />} {/* Affiche la croix */}

      {!isCrossVisible && isRunning && !isPaused && (
        <OptocinetiqueTexte
          text={selectedSentence}
          wpm={wpcm}
          caseSize={caseSize}
          onScrollEnd={handleScrollEnd}
        />
      )}


    </div>
  );
};

const FullScreenCross: React.FC<{ size: number }> = ({ size }) => {
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center">
      <div
        className="relative"
        style={{ width: `${size}px`, height: `${size}px`, position: 'relative' }}
      >
        {/* Barre horizontale */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            height: '2px',
            backgroundColor: 'white',
            transform: 'translate(-50%, -50%)',
          }}
        ></div>
        {/* Barre verticale */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            height: '100%',
            width: '2px',
            backgroundColor: 'white',
            transform: 'translate(-50%, -50%)',
          }}
        ></div>
      </div>
    </div>
  );
};

